import { render, staticRenderFns } from "./SaveNote.vue?vue&type=template&id=191336dd&"
import script from "./SaveNote.vue?vue&type=script&lang=js&"
export * from "./SaveNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports